// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'keyboard';

export const Component = () => (
  <g stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path
      fill='none'
      d='M3.133 4.75h11.734S17 4.75 17 6.875v4.25s0 2.125-2.133 2.125H3.133S1 13.25 1 11.125v-4.25S1 4.75 3.133 4.75z'
    />
    <path d='M5.267 6.875h1.066m5.334 0h1.066m-4.266 0h1.066M3.667 9h1.066m2.134 0h1.066m2.134 0h1.066m2.134 0h1.066m-9.066 2.125h7.466' />
  </g>
);

export const viewBox = '0 0 18 18';
